import React from 'react';
import classnames from 'classnames';
import cookie from 'react-cookies';

import TimeInput from '../TimeInput';
import DayInitialiser from '../DayInitialiser';
import Form from '../../../../../../components/Form/Form';
import Spinner from '../../../../../../components/Spinner';
import Modal from '../../../../../../components/Modal/';

import './ScheduleSelect.scss';

const SegmentLength = 7; // How far each jump goes
const convertPositionToTime = position => { // Assumes known height of 1440px
  let hour = (position - (position % 60)) / 60;
  let mins = position - (hour * 60);

  return `${hour}:${('0' + mins).slice(-2)}`;
};

class ScheduleSelect extends React.Component {
  constructor(props) {
    super(props);

    let startTimestamp = new Date();
    startTimestamp.setDate(startTimestamp.getDate() - (startTimestamp.getDay() + 6) % 7);
    startTimestamp.setHours(0, 0, 0, 0);
    startTimestamp = startTimestamp.getTime();

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const convertUTCValue = UTCEpoch => {
      let d = new Date(0);
      d.setUTCSeconds(UTCEpoch);
      return d;
    };

    const formattedEntries = props.data.getAdvisorScheduleNodes.reduce((sum, value) => {
      const StartDate = convertUTCValue(value.start_timestamp);
      const EndDate = convertUTCValue(value.end_timestamp);

      let DayStart = convertUTCValue(value.start_timestamp);
      DayStart.setHours(0, 0, 0, 0); // The first second of the day

      console.log('Day Dates: ', StartDate, EndDate);
      console.log('Day: ', Math.round(((DayStart.getTime() - startTimestamp) / (oneDay))));

      return Object.assign({}, sum, {
        [value.id]: {
          id: value.id,
          isNegative: value.negative_positive !== 1,
          module_instance: value.module_instance,
          day: Math.round(((DayStart.getTime() - startTimestamp) / (oneDay))),
          // day: Math.floor((DayStart.getTime() - startTimestamp) / 86400000),
          start: (StartDate.getTime() - DayStart.getTime()) / 1000 / 60,
          height: ((EndDate.getTime() - DayStart.getTime()) / 1000 / 60) - ((StartDate.getTime() - DayStart.getTime()) / 1000 / 60)
        },
      });
    }, {});

    let isFirstLoad = false

    if (typeof cookie.load('Schedule_FirstTimeLoad') === 'undefined') {
      cookie.save('Schedule_FirstTimeLoad', Date.now(), {
        path: '/',
      });
      // isFirstLoad = true; //Uncomment this this to push live
    }


    this.state = {
      ScrollOffset: 0,
      totalEntries: formattedEntries,
      lastSaved: formattedEntries,
      displayModal: null,
      isSaved: null,
      modalForm: null,
      toUpdate: [],
      modalError: null,
      currentSegment: 0,
      pendingErrorMessage: '',
      PendingSessionsLoading: [],
      isFirstTimeLoad: isFirstLoad,
    };

    this.handleSegmentMove = this.handleSegmentMove.bind(this);
    this.setSegmentMovement = this.setSegmentMovement.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleModalFormChange = this.handleModalFormChange.bind(this);
    this.handleModalEntryDeleteClick = this.handleModalEntryDeleteClick.bind(this);
    this.handleModalEntryUpdateClick = this.handleModalEntryUpdateClick.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.acceptSession = this.acceptSession.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }

  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  };

  routerWillLeave(nextLocation) {
    if (this.state.changeMade) {
      return 'Your schedule is still being saved. Are you sure you want to leave?';
    }
  };

  handleSegmentMove(direction) {
    return () => {
      let newSegment = this.state.currentSegment + direction;

      if (newSegment < -2) {
        newSegment = -2;
      }

      if (newSegment > 15) {
        newSegment = 15;
      }

      this.setState({
        currentSegment: newSegment,
      });
    };
  }

  setSegmentMovement(val) {
    return () => this.setState({
      currentSegment: val,
    })
  }

  showModal(id = null) {
    this.setState({
      displayModal: id,
      modalError: null,
      modalForm: null,
    });
  }

  handleScroll(event) {
    this.setState({
      ScrollOffset: event.target.scrollTop,
    });
  }

  handleChange(dayID) {
    return (event, shouldSave = true) => {
      this.setState({
        isSaved: false,
      });

      window.onbeforeunload = function () {
        return true;
      };

      let formattedEntries = event.reduce((sum, value) => {
        let newObject = {};

        newObject[value.id] = value;
        newObject[value.id]['day'] = dayID;

        return Object.assign({}, sum, newObject);
      }, this.state.totalEntries);

      const currentState = this.state.lastSaved;
      const Mutations = Object.keys(formattedEntries).reduce((sum, key) => {
        const newNode = formattedEntries[key];
        const oldNode = currentState[key];

        if (Object.prototype.hasOwnProperty.call(currentState, key) === false) { // New node
          return Object.assign({}, sum, {
            created: [
              ...sum.created,
              newNode,
            ],
          });
        }

        if (newNode.start !== oldNode.start || newNode.height !== oldNode.height) { // Updated node
          if (Object.prototype.hasOwnProperty.call(newNode, 'id')) {
            return Object.assign({}, sum, {
              changed: [
                ...sum.changed,
                newNode,
              ],
            });
          }
        }

        return sum;
      }, { changed: [], created: [] });

      this.setState({ // Temp State change
        totalEntries: formattedEntries,
        toUpdate: [],
      });

      const cleanzeDate = Epoch => Epoch / 1000;

      if (shouldSave) {
        (() => {
          if (Mutations.created.length > 0) {
            return this.props.createAdvisorNodes({ // Create new nodes
              variables: {
                Nodes: Mutations.created.map(val => {
                  let startTimestamp = new Date();
                  startTimestamp.setHours(0, 0, 0, 0);
                  startTimestamp.setDate(startTimestamp.getDate() + val.day - (startTimestamp.getDay() + 6) % 7);

                  const Timestamp = startTimestamp.getTime();

                  return (
                    {
                      'start': cleanzeDate(Timestamp + (val.start * 60000)),
                      'end': cleanzeDate(Timestamp + (val.start * 60000) + (val.height * 60000)),
                      'isPositive': true
                    }
                  );
                })
              }
            })
              .catch(err => {
                Bugsnag.notifyException(err);
                window.location.replace(window.location.pathname + window.location.search + window.location.hash);
              });
          }

          return Promise.resolve({ data: { createAdvisorScheduleNodes: [] } });
        })()
          .then(data => {
            const TempIDs = Mutations.created.map(x => x.id);

            formattedEntries = Object.keys(formattedEntries).reduce((sum, key, index) => {
              const findIndex = TempIDs.indexOf(key);
              if (findIndex >= 0) {
                const newID = data.data.createAdvisorScheduleNodes[findIndex].id;

                return Object.assign({}, sum, {
                  [newID]: Object.assign({}, formattedEntries[key], {
                    id: newID,
                  })
                });
              }

              return Object.assign({}, sum, {
                [key]: formattedEntries[key]
              });
            }, {});

            if (Mutations.changed.length > 0) {
              return this.props.updateAdvisorNodes({ // Update changed nodes
                variables: {
                  Nodes: Mutations.changed.map(val => {
                    let startTimestamp = new Date();
                    startTimestamp.setHours(0, 0, 0, 0);
                    startTimestamp.setDate(startTimestamp.getDate() + val.day - (startTimestamp.getDay() + 6) % 7);
                    const Timestamp = startTimestamp.getTime();

                    return (
                      {
                        'id': val.id,
                        'start': cleanzeDate(Timestamp + (val.start * 60000)),
                        'end': cleanzeDate(Timestamp + (val.start * 60000) + (val.height * 60000)),
                        'isPositive': true
                      }
                    );
                  })
                }
              })
                .catch(err => {
                  Bugsnag.notifyException(err);
                  window.location.replace(window.location.pathname + window.location.search + window.location.hash);
                });
            }

            return Promise.resolve(data);
          })
          .then(data => {
            this.setState({
              totalEntries: formattedEntries,
              lastSaved: formattedEntries,
              toUpdate: [],
              isSaved: true,
            });
            window.onbeforeunload = null;

            window.setTimeout(function () {
              this.setState({
                isSaved: null,
              });
            }.bind(this), 2000);
          });
      } else {
        this.setState({
          isSaved: null,
        });
        window.onbeforeunload = null;
      }
    };
  }

  handleModalFormChange(event) {
    this.setState({
      modalForm: event.target.value,
    });
  }

  handleModalEntryDeleteClick() {
    this.setState({
      totalEntries: Object.assign({}, this.state.totalEntries, {
        [this.state.displayModal]: {},
      }),
      isSaved: false,
      modalForm: null,
      displayModal: null,
    });

    this.props.deleteAdvisorNodes({
      variables: {
        Nodes: [this.state.displayModal],
      },
    })
      .then(Data => {
        this.setState({
          isSaved: true,
        });

        window.setTimeout(function () {
          this.setState({
            isSaved: null,
          });
        }.bind(this), 2000);
      })
      .catch(err => {
        Bugsnag.notifyException(err);
        window.location.replace(window.location.pathname + window.location.search + window.location.hash);
      });
  }

  handleModalEntryUpdateClick(newEntry) {
    const FormData = (this.state.modalForm === null) ? {} : this.state.modalForm;
    const convertTimeStampToOffset = timestamp => parseInt(timestamp.split(':')[1]) + parseInt(timestamp.split(':')[0]) * 60;

    let newHeight = newEntry.height;
    let newStart = newEntry.start;

    if (Object.prototype.hasOwnProperty.call(FormData, 'StartTime')) {
      newHeight = newHeight + (newStart - convertTimeStampToOffset(FormData.StartTime));
      newStart = convertTimeStampToOffset(FormData.StartTime);
    }

    if (Object.prototype.hasOwnProperty.call(FormData, 'EndTime')) {
      newHeight = convertTimeStampToOffset(FormData.EndTime) - newStart;
    }

    if (newStart > 0) {
      if (newHeight > 0) {
        this.setState({
          toUpdate: [
            ...this.state.toUpdate,
            Object.assign({}, newEntry, {
              height: newHeight,
              start: newStart,
            }),
          ],
          modalForm: null,
          displayModal: null,
          modalError: null,
        });
        return;
      }
    }

    this.setState({
      modalError: "End time cannot be prior to start time",
    });
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.showModal(null);
    }
  }
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    this.props.AdvisorSessions.startPolling(30000);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  renderModal() { // TODO - Refactor to use the new generic modal component
    const SelectedEntry = (typeof this.state.displayModal === 'object') ? null : this.state.totalEntries[this.state.displayModal];
    const isValidInput = () => {
      console.log(this.state);

      if (this.state.modalForm !== null) {
        return true;
      }

      return false;
    }

    return (
      <div className='ScheduleSelect__ModalWrapper'>
        <div className='ScheduleSelect_Background' onClick={() => this.showModal(null)} />
        {(SelectedEntry !== null) ? (
          <div className='ScheduleSelect_ModalInternal'>
            <a className='ScheduleSelect__ModalCloseButton' onClick={() => this.showModal(null)}>×</a>
            <h4>Edit Time Slot</h4>
            <Form onChange={this.handleModalFormChange}>
              {(this.modalError !== null) ? (
                <p className='text-error'>{this.state.modalError}</p>
              ) : null}
              <div className='row'>
                <div className='col'>
                  <p className='ScheduleSelect__TimeInput'>Start Time</p>
                  <TimeInput name='StartTime' className='ScheduleSelect__InputLabel' initTime={('0' + convertPositionToTime(SelectedEntry.start)).slice(-5)} />
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <p className='ScheduleSelect__TimeInput'>End Time</p>
                  <TimeInput name='EndTime' className='ScheduleSelect__InputLabel' initTime={('0' + convertPositionToTime(SelectedEntry.start + SelectedEntry.height)).slice(-5)} />
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <a onClick={() => this.handleModalEntryUpdateClick(this.state.totalEntries[this.state.displayModal])} className='btn positive'>Update</a>
                  <a onClick={this.handleModalEntryDeleteClick} className='btn negative'>Delete</a>
                  <a onClick={() => this.showModal(null)} className='btn btn--cancel'>Cancel</a>
                </div>
              </div>
            </Form>
          </div>
        ) : (
            <div className='ScheduleSelect_ModalInternal'>
              <a className='ScheduleSelect__ModalCloseButton' onClick={() => this.showModal(null)}>×</a>
              <h4>Create Time Slot</h4>
              <Form onChange={this.handleModalFormChange}>
                {(this.modalError !== null) ? (
                  <p className='text-error'>{this.state.modalError}</p>
                ) : null}
                <div className='row'>
                  <div className='col'>
                    <p className='ScheduleSelect__TimeInput'>Start Time</p>
                    <TimeInput name='StartTime' className='ScheduleSelect__InputLabel' initTime={('0' + convertPositionToTime(this.state.displayModal.start)).slice(-5)} />
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    <p className='ScheduleSelect__TimeInput'>End Time</p>
                    <TimeInput name='EndTime' className='ScheduleSelect__InputLabel' initTime={('0' + convertPositionToTime(this.state.displayModal.start + this.state.displayModal.height)).slice(-5)} />
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    <a onClick={() => this.handleModalEntryUpdateClick(Object.assign({}, this.state.displayModal, {
                      id: (new Date().getSeconds()).toString() + (new Date().getUTCMilliseconds()).toString(),
                    }))} className='btn positive'>Create</a>
                    <a onClick={() => this.showModal(null)} className='btn btn--cancel'>Cancel</a>
                  </div>
                </div>
              </Form>
            </div>
          )}
      </div>
    );
  }

  getToDelete(day) {
    if (this.state.toDelete.length > 0) {
      return this.state.toDelete.filter(entry => entry.day === day);
    }
    return [];
  }

  getToUpdate(day) {
    if (this.state.toUpdate.length > 0) {
      return this.state.toUpdate.filter(entry => entry.day === day);
    }
    return [];
  }

  renderLoadingFlash() {
    if (this.state.isSaved !== null) {
      if (this.state.isSaved === false) {
        return (
          <div className='SaveFlash SaveFlash--Saving'>
            <Spinner className='spinner--white' />
            <span>Saving</span>
          </div>
        );
      }
      return (
        <div className='SaveFlash SaveFlash--Saved'>
          <span>Saved</span>
        </div>
      );
    }

    return null;
  }

  acceptSession(ModuleInstance) {
    return event => {
      const CurrentDay = (() => {
        let startTimestamp = new Date();
        startTimestamp.setDate(startTimestamp.getDate() - (startTimestamp.getDay() + 6) % 7);
        startTimestamp.setHours(0, 0, 0, 0);

        return Math.ceil((Date.now() - startTimestamp) / 86400000);
      })()

      const HoursInputted = Object.keys(this.state.totalEntries).reduce((sum, key) => {
        if (Object.prototype.hasOwnProperty.call(this.state.totalEntries[key], 'height')) {
          if (this.state.totalEntries[key].day >= CurrentDay) {
            if (Object.prototype.hasOwnProperty.call(this.state.totalEntries[key], 'isNegative')) {
              if (this.state.totalEntries[key].isNegative) {
                return sum - (this.state.totalEntries[key].height / 60);
              }
            }
            return sum + (this.state.totalEntries[key].height / 60);
          }
        }
        return sum;
      }, 0); // Number of hours currently available for the student to choose from

      const HoursNeeded = this.props.AdvisorSessions.listSessions.reduce((sum, ModuleInstance) => {
        if (ModuleInstance.module_instance_status.id > 22 && ModuleInstance.module_instance_status.id < 60) {
          return sum + 1;
        }
        return sum;
      }, 3); // Hours needed to be allowed to schedule currently. Based off number of currently scheduled


      console.log(HoursInputted, HoursNeeded)

      if (HoursInputted >= HoursNeeded) {
        this.setState({
          pendingErrorMessage: '',
          PendingSessionsLoading: [
            ...this.state.PendingSessionsLoading,
            ModuleInstance,
          ]
        })
        this.props.AcceptSession({
          variables: {
            ModuleInstance: ModuleInstance,
          }
        }).then(() => {
          this.props.AdvisorSessions.refetch();
          this.setState({
            PendingSessionsLoading: this.state.PendingSessionsLoading.filter(x => x !== ModuleInstance)
          })
        })
      } else {
        this.setState({
          pendingErrorMessage: ('Please input at least ' + HoursNeeded + ' hours of availability over the next 3 weeks before accepting this session request.  (we don\'t count times today because it\'s too short notice in most cases)'),
        })
      }
    }
  }

  renderPendingSessions() {
    if (Object.prototype.hasOwnProperty.call(this.props.AdvisorSessions, 'listSessions')) {
      console.log('Render', JSON.stringify(this.PendingSessionsLoading));

      return (
        <div className='PendingSessions'>
          <h3>Approve Student Session Requests</h3>
          <p>After inputting your available times below, please return here to ACCEPT the sessions you can complete. Only accepted sessions will be sent to the student for scheduling.</p>
          <p style={{ color: '#e52626' }}>{this.state.pendingErrorMessage}</p>
          {
            this.props.AdvisorSessions.listSessions.filter(x => x.module_instance_status !== null).filter(x => x.module_instance_status.id === 22).map((ModuleInstance, Index) => {
              return (
                <div className="PendingSessions__Entry" key={Index}>
                  <div className="row">
                    <div className="col">
                      <h6>{ModuleInstance.module.module_name}</h6>
                      <p><b>Student: </b>{ModuleInstance.student.first_name + ' ' + ModuleInstance.student.last_name}</p>
                      {(ModuleInstance.module.description !== null) ? <p>{ModuleInstance.module.description}</p> : null}
                    </div>
                    <div className="col">
                      <div className="clearfix">
                        <a className='btn negative' href={"/scheduler/reject/" + ModuleInstance.id} target="_blank">Reject</a>
                        <button onClick={this.acceptSession(ModuleInstance.id)} className='btn positive'>{(this.state.PendingSessionsLoading.includes(ModuleInstance.id)) ? <Spinner className='spinner--white' /> : 'Accept'}</button>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          }
          {(this.props.AdvisorSessions.listSessions.filter(x => x.module_instance_status !== null).filter(x => x.module_instance_status.id === 22).length === 0 ? <h6 style={{ margin: '0' }}>No pending session requests</h6> : null)}
        </div>
      )
    }
    return null;
  }

  showErrorModal = () => this.ErrorModal.openModal();

  render() {
    const convertTime = time => {
      if ((time + 1) < 12) {
        return `${time + 1}am`;
      }
      if (time === 11) {
        return `12pm`;
      }
      return `${time - 11}pm`;
    };

    const getHeaderDay = DayOffset => {
      const Days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const Months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      const SegmentOffset = this.state.currentSegment;
      let startTimestamp = new Date();
      startTimestamp.setDate(startTimestamp.getDate() - (startTimestamp.getDay() + 6) % 7);
      startTimestamp = startTimestamp.getTime();

      const DayDate = new Date(startTimestamp + (DayOffset * 86400000) + (SegmentOffset * 86400000 * SegmentLength));

      return `${Days[DayDate.getDay()]} - ${DayDate.getDate()} ${Months[DayDate.getMonth()]}`;
    };

    const DayData = Object.keys(this.state.totalEntries).reduce((sum, key) => {
      const Node = this.state.totalEntries[key];

      sum[(Node.day)] = [
        ...sum[Node.day] || [],
        Node,
      ];

      return sum;
    }, {});

    const TimeZone = () => {
      let ReturnString = 'UTC' + ((new Date().getTimezoneOffset() > 0) ? '-' : '+') + Math.abs((new Date().getTimezoneOffset() / 60));

      if (typeof Intl !== 'undefined') { // Older browsers do not support localised Timezones
        ReturnString = Intl.DateTimeFormat().resolvedOptions().timeZone + ' (' + ReturnString + ')'
      }

      return ReturnString;
    }

    const defaultValue = (value, defaultVal) => {
      if (typeof value === 'undefined' || value === null) {
        return defaultVal;
      }

      return value;
    };

    const segmentDays = SegmentLength * this.state.currentSegment;

    const CurrentDay = (() => {
      let startTimestamp = new Date();
      startTimestamp.setDate(startTimestamp.getDate() - (startTimestamp.getDay() + 6) % 7);
      startTimestamp.setHours(0, 0, 0, 0);

      return Math.ceil((Date.now() - startTimestamp) / 86400000);
    })()

    return (
      <div>
        <Modal startOpen={this.state.isFirstTimeLoad}>
          I need copy from Byron
        </Modal>
        <Modal onRef={ref => this.ErrorModal = ref}>
          Times cannot be inputted in the current day as same day bookings are not supported.
        </Modal>
        {(this.state.displayModal !== null) ? this.renderModal() : null}
        {this.renderLoadingFlash()}
        <div className='container'>
          <div className='ScheduleSelect__Wrapper'>
            <div style={{ paddingLeft: '45px' }}>
              <h1>Advisor Schedule Manager</h1>
              {this.renderPendingSessions()}
              <h3>Input your Available Times</h3>
              <p>After you receive a session request, use the below calendar to tell us when you are free over the next 10 or so days.  Your inputs are auto-saved.  If possible, please try to spread the times out a bit in case the student is unavailable. Times during today are not counted, because same-day sessions cannot be booked.</p>
            </div>
            <div className='row'>
              <div className='col'>
                <p style={{ paddingLeft: '45px', lineHeight: '40px', margin: 0 }}>{'Your time zone is ' + TimeZone()}</p>
              </div>
              <div className='col-md-6'>
                <div className='SegmentNav__Wrapper clearfix'>
                  <div onClick={this.handleSegmentMove(-1)} className={classnames({
                    'SegmentNav__button': true,
                    'SegmentNav__button--inactive': this.state.currentSegment === -2
                  })}>
                    &#60;
                  </div>
                  <div onClick={this.setSegmentMovement(0)} className={classnames({
                    'SegmentNav__button': true,
                    'today': true,
                  })}>
                    Today
                  </div>
                  <div onClick={this.handleSegmentMove(1)} className={classnames({
                    'SegmentNav__button': true,
                    'SegmentNav__button--inactive': this.state.currentSegment === 15
                  })}>
                    &#62;
                  </div>
                </div>
              </div>
            </div>
            <div className="SchedulerWrappingContainer">
              <div className="SchedulerWrappingInnerContainer">
                <div className='ScheduleSelect__LeftOffset'>
                  <div className='row'>
                    {
                      Array.from(Array(7)).map((x, i) => (
                        <div className='col' key={i}>
                          <div className='ScheduleSelect__DayHeader'>
                            <h5>{getHeaderDay(i)}</h5>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
                <div ref='scrollWrapper' onScroll={this.handleScroll} className='ScheduleSelect__OverflowWrapper'>
                  <div className='ScheduleSelect__LeftOffset'>
                    <div className='ScheduleSelect__MarkerWrap'>
                      {Array.apply(null, { length: 24 }).map((x, index) => (
                        <div key={index} className='ScheduleSelect__Marker'>
                          {convertTime(index)}
                          <div className='ScheduleSelect__Marker--Line' />
                        </div>
                      ))}
                    </div>
                    <div className='row'>
                      {
                        Array.from(Array(7)).map((x, i) => (
                          <div className='col' key={segmentDays + i}>
                            <div className='ScheduleSelect__DayWrapper'>
                              <DayInitialiser existingData={defaultValue(DayData[(segmentDays + i)], [])} day={segmentDays + i} showErrorModal={this.showErrorModal}
                                handleUpdate={this.getToUpdate(segmentDays + i)} displayModal={this.showModal} ScrollOffset={this.state.ScrollOffset} onChange={this.handleChange(segmentDays + i)} />
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
                <div className='ScheduleSelect__LeftOffset'>
                  <div className='row'>
                    {
                      Array.from(Array(7)).map((x, i) => (
                        <div className='col' key={i}>
                          <div className='ScheduleSelect__DayHeader'>
                            <h5>{getHeaderDay(i)}</h5>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ScheduleSelect;



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/ViewScheduler/components/ScheduleSelect/index.js